import { render, staticRenderFns } from "./PlatformSetting.vue?vue&type=template&id=436afcb4&scoped=true"
import script from "./PlatformSetting.vue?vue&type=script&lang=js"
export * from "./PlatformSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436afcb4",
  null
  
)

export default component.exports